export default "__VITE_ASSET__DmYRAR_I__"